<template>
    <div style="page-break-before: always" class="w-full">
        <app-separator>
            <h1>{{ $t('meetings.amendments') }}</h1>
        </app-separator>
        <table class="mt-4 w-full text-xs border">
            <thead class="table-header-group font-bold table-fixed">
                <tr class="border">
                    <td class="p-1" style="width: 33%">{{ $t('commons.bundle') }}</td>
                    <td class="p-1" style="width: 33%">{{ $t('amendments.object') }}</td>
                    <td class="p-1" style="width: 12ch">{{ $t('amendments.emissionDueDateShort') }}</td>
                    <td class="p-1" style="width: 12ch">{{ $t('amendments.emissionDateShort') }}</td>
                    <td class="p-1" style="width: 10ch">{{ $t('commons.status') }}</td>
                    <td class="p-1" style="width: 9ch">{{ $t('amendments.amountHT') }}</td>
                </tr>
            </thead>
            <tbody>
                <template v-for="amendment in amendments">
                    <tr class="border">
                        <td class="p-1 align-top">
                            <app-bundle :bundle="amendment.bundle" bundleNameClass="font-normal"></app-bundle>
                        </td>
                        <td class="p-1 align-top" :data-key="amendment.id">
                            <router-link
                                :to="{
                                    name: 'followAmendment',
                                    params: { projectId: $route.params.projectId, amendmentId: amendment.id },
                                }"
                            >
                                {{ amendment.object }}
                            </router-link>
                        </td>
                        <td class="p-1 align-top">
                            {{ amendment.emissionDueDate | humanizeDate }}
                        </td>
                        <td class="p-1 align-top">
                            {{ amendment.emissionDate | humanizeDate }}
                        </td>
                        <td class="p-1">
                            {{
                                amendment.quoteStatus.length > 0
                                    ? $t('amendments.quoteStatus.' + amendment.quoteStatus)
                                    : ''
                            }}
                        </td>
                        <td class="p-1 text-right">
                            {{ (amendment.amountHT > 0 ? '+' : '') + $n(amendment.amountHT, currencyFormat) }}
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>
<script>
import AppSeparator from '@/components/appSeparator/AppSeparator';
import { getAmendments } from '@/features/amendments/amendments.service';
import AppBundle from '@/components/app-bundle/appBundle.vue';
import { combineLatest } from 'rxjs';
import { getBundleMap } from '@/features/bundles/bundles.service';
export default {
    components: { AppBundle, AppSeparator },
    async created() {
        this.subscriptions = [
            combineLatest([
                getBundleMap(this.$route.params.projectId),
                getAmendments(this.$route.params.projectId),
            ]).subscribe(([bundleMap, amendments]) => {
                this.amendments = amendments
                    .filter((amendment) => amendment.type !== 'penalty')
                    .map((amendment) => ({ ...amendment, bundle: bundleMap[amendment.bundleId] }));
            }),
        ];
    },
    data() {
        return {
            currencyFormat: {
                currency: 'EUR',
                currencyDisplay: 'symbol',
                style: 'currency',
                minimumFractionDigits: 2,
            },
            subscriptions: [],
            amendments: [],
        };
    },
};
</script>
